import { __awaiter } from 'tslib';
import { Buffer } from 'buffer';
import 'long';
import '../../proto/index.js';
import { ErrorType } from '../../core/consts.js';
import { Logger } from '../../core/metrics/logger.js';
import { BaseError } from '../../core/errors/BaseError.js';
import '../../core/metrics/monitor.js';
import '../../core/network/NetworkItem.js';
import { ServiceIdentity } from '../../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';
import { StorageMonitorItem } from '../metrics/StorageMetrics.js';

function generateKeyFromPassPhrase(ctx, passPhrase) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const digest = yield ((_b = (_a = window.crypto) === null || _a === void 0 ? void 0 : _a.subtle) === null || _b === void 0 ? void 0 : _b.digest('SHA-256', Buffer.from(passPhrase)));
        return (_d = (_c = window.crypto) === null || _c === void 0 ? void 0 : _c.subtle) === null || _d === void 0 ? void 0 : _d.importKey('raw', digest, 'AES-CTR', false, ['encrypt', 'decrypt']).catch(e => {
            ctx.resolve(ServiceIdentity.Monitor).emitCounter(StorageMonitorItem.PassphraseError);
            Logger.ctxWarn(ctx, 'generateKeyFromPassPhrase error', e);
        });
    });
}
function encrypt(ctx, key, data) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const counter = Buffer.from(window.crypto.getRandomValues(new Uint8Array(16)), 0, 16);
            const encryptRes = yield ((_b = (_a = window.crypto) === null || _a === void 0 ? void 0 : _a.subtle) === null || _b === void 0 ? void 0 : _b.encrypt({
                name: 'AES-CTR',
                counter,
                length: 128
            }, key, Buffer.from(JSON.stringify(data))));
            return {
                ciphertext: Buffer.from(encryptRes).toString('hex'),
                iv: counter.toString('hex')
            };
        }
        catch (error) {
            Logger.ctxWarn(ctx, 'encrypt error, using fallback hex, error:', error, 'data:', data);
            ctx.resolve(ServiceIdentity.Monitor).emitCounter(StorageMonitorItem.EncryptError);
            // 加密失败直接转 hex
            return {
                ciphertext: Buffer.from(JSON.stringify(data)).toString('hex')
            };
        }
    });
}
function decrypt(ctx, key, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let decryptedData;
            if (data.iv) {
                const ciphertext = Buffer.from(data.ciphertext, 'hex');
                const counter = Buffer.from(data.iv, 'hex');
                const decryptRes = yield window.crypto.subtle.decrypt({
                    name: 'AES-CTR',
                    counter,
                    length: 128
                }, key, ciphertext);
                decryptedData = JSON.parse(Buffer.from(new Uint8Array(decryptRes)).toString());
            }
            else if (data.ciphertext) {
                // 处理加密失败转 hex 的数据
                decryptedData = JSON.parse(Buffer.from(data.ciphertext).toString());
            }
            else {
                throw new BaseError({
                    ctx,
                    type: ErrorType.StorageCryptoError,
                    sender: data,
                    msg: 'unhandled decrypted data'
                });
            }
            return decryptedData;
        }
        catch (error) {
            ctx.resolve(ServiceIdentity.Monitor).emitCounter(StorageMonitorItem.DecryptError);
            if (error instanceof BaseError) {
                throw error;
            }
            throw new BaseError({
                ctx,
                type: ErrorType.StorageCryptoError,
                sender: data,
                msg: 'decryption failed'
            });
        }
    });
}

export { decrypt, encrypt, generateKeyFromPassPhrase };
//# sourceMappingURL=crypto.js.map
